const en = {
	common: require("@locales/en/common.json"),
	header: require("@locales/en/header.json"),
};

const de = {
	common: {},
	header: {},
};

module.exports = {
	en,
	de,
};
